/**
 * Zoho Popup Functionality
 * Handles multiple Zoho contact form overlays on the same page
 * Including newsletter popup with iframe support
 */

export function initZohoPopup() {
	// Handle all zoho triggers with data attributes
	document.querySelectorAll('[data-zoho-overlay]').forEach(function(trigger) {
		trigger.addEventListener('click', function() {
			const targetId = this.getAttribute('data-zoho-overlay');
			const overlay = document.getElementById(targetId);
			if (overlay) {
				showOverlay(overlay);
			}
		});
	});
	
	// Handle all close buttons with data-target
	document.querySelectorAll('.zoho-close').forEach(function(closeBtn) {
		closeBtn.addEventListener('click', function() {
			const targetId = this.getAttribute('data-target');
			const overlay = document.getElementById(targetId);
			if (overlay) {
				hideOverlay(overlay);
			}
		});
	});
	
	// Handle newsletter popup (specific implementation)
	const newsletterBtn = document.getElementById('newsletter-btn');
	const newsletterOverlay = document.getElementById('newsletter-overlay');
	const closeOverlayBtn = document.getElementById('close-overlay');
	
	if (newsletterBtn && newsletterOverlay) {
		newsletterBtn.addEventListener('click', function() {
			showOverlay(newsletterOverlay);
		});
	}
	
	if (closeOverlayBtn && newsletterOverlay) {
		closeOverlayBtn.addEventListener('click', function() {
			hideOverlay(newsletterOverlay);
		});
	}
	
	// Close overlay when clicking outside the modal content
	document.querySelectorAll('.zoho-overlay, #newsletter-overlay').forEach(function(overlay) {
		overlay.addEventListener('click', function(e) {
			if (e.target === this) {
				hideOverlay(this);
			}
		});
	});
}

/**
 * Show overlay with proper class handling
 * @param {Element} overlay - The overlay element to show
 */
function showOverlay(overlay) {
	overlay.classList.remove('hidden');
	// Add flex class if the overlay uses flexbox layout (like newsletter)
	if (overlay.id === 'newsletter-overlay') {
		overlay.classList.add('flex');
	}
}

/**
 * Hide overlay with proper class handling
 * @param {Element} overlay - The overlay element to hide
 */
function hideOverlay(overlay) {
	overlay.classList.add('hidden');
	// Remove flex class if it was added
	if (overlay.id === 'newsletter-overlay') {
		overlay.classList.remove('flex');
	}
}